import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Add, Height, Image, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
import { Assignment } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

//servicios
import { wsGetAll, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100, align: 'center' },
  { Header: 'Nro. documento', accessor: 'NumAtCard'},
  { Header: 'Fec documento', accessor: 'TaxDate'},
  { Header: 'Cód. cliente', accessor: 'CardCode'},
  { Header: 'Nom cliente', accessor: 'CardName'},
  { Header: 'Fec último pago', accessor: 'FechaUltimoPago'},
  { Header: 'Total documento', accessor: 'DocTotal'},
  { Header: 'Total pagado', accessor: 'PaidToDate'},
  { Header: 'Saldo pendiente', accessor: 'Saldo'},
  { Header: 'Cant pagos', accessor: 'Pagos'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];


export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [currentAccount, setAccount] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});

  async function loadCurrentAccount(filter) {
    setDataLoading(true);
    let response = await wsFindBy('pymt/current-account',filter);
    setDataLoading(false);
    if (response.success) setAccount(response.data);
  }

  return (
    <GridContainer>
      {model.open ? (
          <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCurrentAccount()}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Cuentas Corrientes {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCurrentAccount}
              getValueSearch={(value) => {setValueSearch(value);}}
              dateRange
              diffRange={0}
              customer
            />
            <ReactTable
              excelName="listado_respuestas_supervisores"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={currentAccount.map((item, i) => {
                return {
                  num: (
                    <>
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_SHOW}>
                          <Button justIcon round simple color={props.themeContext.buttonColorWarning} 
                          style={{padding:'0',width:'31px',height:'31px',minWidth:'31px'}}>
                            <Link to={`${item.DocEntry}`} style={{margin:'0'}}>
                              <Visibility />
                            </Link>
                          </Button>
                        </AllowedGuard>
                      </div>
                    </>
                  ),
                  DocEntry: item.DocEntry,
                  ObjType: item.ObjType,
                  TaxDate: item.TaxDate,
                  NumAtCard: item.NumAtCard,
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  FechaUltimoPago: item.FechaUltimoPago,
                  DocTotal: item.DocTotal,
                  PaidToDate: item.PaidToDate,
                  Saldo: item.Saldo,
                  Pagos: item.Pagos,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
